<template>
    <div class="select-table-wrapper">
        <b-table
            class="w-100 h-100 items-table"
            table-class="h-100"
            empty-text="No items"
            select-mode="single"
            show-empty
            selectable
            striped
            hover
            responsive
            :fields="fields"
            :items="items"
            @row-selected="itemSelected"
        >
            <template v-for="(_, slotName, index) of slots" v-slot:[slotName]="scope">
                <div :key="`${slotName}-${index}`">
                    <slot :name="slotName" v-bind="scope" />
                </div>
            </template>
        </b-table>
    </div>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue';

const emit = defineEmits<{
    (event: 'item-selected', value: unknown): void;
}>();

withDefaults(
    defineProps<{
        items: unknown[];
        fields?: unknown[];
    }>(),
    {
        fields: () => []
    }
);

const slots = useSlots();

const itemSelected = (item: unknown) => {
    emit('item-selected', item);
};
</script>

<style lang="scss" scoped>
.select-table-wrapper {
    ::v-deep {
        td * {
            max-height: initial !important;
        }
    }
}
</style>
